export const navLinkData = [
  {
    linkName: 'about',
    linkRedirect: 'about',
    spy: true,
    smooth: true,
    id: 'about'
  },
  {
    linkName: 'services',
    linkRedirect: 'services',
    spy: true,
    smooth: true,
    id: 'services'
  },
  {
    linkName: 'doctors',
    linkRedirect: 'doctors',
    spy: true,
    smooth: true,
    id: 'doctors'
  },
  {
    linkName: 'partners',
    linkRedirect: 'partners',
    spy: true,
    smooth: true,
    id: 'partners'
  },
  {
    linkName: 'contact',
    linkRedirect: 'contact',
    spy: true,
    smooth: true,
    id: 'contact'
  }
]